module.exports = new __parcel__URL__("migration-logo.25f5c840.svg").toString();